// import jsonMap from './../../uploads/map.json';
import axios from 'axios';

export default () => {

let blueColorMap = "#46bcec";

let stylesMap = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "administrative.province",
        "elementType": "labels.icon",
        "stylers": [
            {
                "hue": "#ff0000"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": blueColorMap
            },
            {
                "visibility": "on"
            }
        ]
    }
];
// let data;

const mainMapSearch = document.querySelectorAll('.main-map--init')
mainMapSearch.forEach(n => {
    let dataFullJson;
    let dataJsonLang;
    let markersOnMap;

    axios.get(window.locationsJSON).then(response => {
        dataJsonLang = Object.values(response.data);
        dataFullJson = Object.values(response.data);
        markersOnMap = Object.values(response.data);
        initMap();

    })

    function initMap() {
        let InforObj = [];
        let centerCords;
        let zoomMap;
        if(n.getAttribute("data-post-id")) {
            let id = n.dataset.postId;
            let findObjJson = markersOnMap.find(item => item.placeId == id);
            centerCords = {
                lat: findObjJson.placeLat,
                lng: findObjJson.placeLng,
            };
            zoomMap = 14;
        } else {
            centerCords = new google.maps.LatLng(markersOnMap[0].placeLat, markersOnMap[0].placeLng),
            zoomMap = markersOnMap[0].zoomMapDefault;
        }

        let options = {
            zoom: zoomMap,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: centerCords,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            styles: stylesMap
        };

        let myMap = new google.maps.Map(n, options);

        if(n.getAttribute("data-post-id")) {
            oneDots ();
        } else {
            allDots();
        }

        function allDots () {
            let latlngbounds = new google.maps.LatLngBounds();

            for (let i = 0; i < markersOnMap.length; i++) {
                let contentString = '<div class="mpp" id="' + markersOnMap[i].placeId + '">'
                            + '<a href="' + markersOnMap[i].placeUrl + '" class="mppimg"><img src="' + markersOnMap[i].placeImg + '" alt="img"></a>'
                            + '<div class="mppinfo">'
                            + '<div class="avtor">'
                            + '<a href="' + markersOnMap[i].placeUrl + '" class="avtor__name">' + markersOnMap[i].placeName + '</a>'
                            + '<div class="avtor__txt">' + markersOnMap[i].placeTxt + '</div>'
                            + '</div>'
                            + '<div class="card-news__desc">' + markersOnMap[i].placeDesc + '</div>'
                            + '</div>'
                            + '</div>';

                let myLatlng = new google.maps.LatLng(markersOnMap[i].placeLat, markersOnMap[i].placeLng);

                const marker = new google.maps.Marker({
                    position: myLatlng,
                    map: myMap,
                    icon: urlMarkerMap
                });
                const infowindow = new google.maps.InfoWindow({
                    content: contentString,
                });
                marker.addListener("click", () => {
                    closeOtherInfo();
                    infowindow.open(marker.get('myMap'), marker);
                    InforObj[0] = infowindow;
                    pixelOffset: new google.maps.Size(100, 0);
                });
                latlngbounds.extend(marker.position);
            }

            let bounds = new google.maps.LatLngBounds();

            myMap.setCenter(latlngbounds.getCenter());
            myMap.fitBounds(latlngbounds);
        }

        function oneDots () {
            let id = n.dataset.postId;
            let findObjJson = markersOnMap.find(item => item.placeId == id);
            let contentString = '<div class="mpp" id="' + findObjJson.placeId + '">'
                + '<a href="' + findObjJson.placeUrl + '" class="mppimg"><img src="' + findObjJson.placeImg + '" alt="img"></a>'
                + '<div class="mppinfo">'
                + '<div class="avtor">'
                + '<a href="' + findObjJson.placeUrl + '" class="avtor__name">' + findObjJson.placeName + '</a>'
                + '<div class="avtor__txt">' + findObjJson.placeTxt + '</div>'
                + '</div>'
                + '<div class="card-news__desc">' + findObjJson.placeDesc + '</div>'
                + '</div>'
                + '</div>';

            const marker = new google.maps.Marker({
                position: {
                    lat: findObjJson.placeLat,
                    lng: findObjJson.placeLng,
                },
                map: myMap,
                icon: urlMarkerMap
            });
            const infowindow = new google.maps.InfoWindow({
                content: contentString,
            });
            marker.addListener("click", () => {
                closeOtherInfo();
                infowindow.open(marker.get('myMap'), marker);
                InforObj[0] = infowindow;
                pixelOffset: new google.maps.Size(100, 0);
            });
        }


        function closeOtherInfo() {
            if (InforObj.length > 0) {
                /* detach the info-window from the marker ... undocumented in the API docs */
                InforObj[0].set("marker", null);
                /* and close it */
                InforObj[0].close();
                /* blank the array */
                InforObj.length = 0;
            }
        }

    };
});

const mainMapSearchContact = document.querySelectorAll('.main-map--init-сontact')
mainMapSearchContact.forEach(n => {
    initMapContact();

    function initMapContact() {

        // let map = document.getElementById('mainMap');
        let InforObj = [];

        let latMap = n.dataset.lat;
        let lngMap = n.dataset.lng;
        let zoomMap = n.dataset.zoom;
        let centerCords = {
            lat: Number(latMap),
            lng: Number(lngMap)
        };

        let options = {
            zoom: Number(zoomMap),
            // mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: centerCords,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            styles: stylesMap
        };

        // console.log(latMap);

        let myMap = new google.maps.Map(n, options);

        oneDots ();

        function oneDots() {
            let adrMap = n.dataset.address;
            let contentString = '<div class="mpp" id="">'
                + '<div class="mppinfo">'
                + '<div class="avtor">'
                + '<div class="avtor__name">' + adrMap + '</div>'
                + '</div>'
                + '</div>'
                + '</div>';

            const marker = new google.maps.Marker({
                position: centerCords,
                map: myMap,
                icon: urlMarkerMap
            });
            const infowindow = new google.maps.InfoWindow({
                content: contentString,
            });
            marker.addListener("click", () => {
                closeOtherInfo();
                infowindow.open(marker.get('myMap'), marker);
                InforObj[0] = infowindow;
                pixelOffset: new google.maps.Size(100, 0);
            });
        }

        function closeOtherInfo() {
            if (InforObj.length > 0) {
                InforObj[0].set("marker", null);
                InforObj[0].close();
                InforObj.length = 0;
            }
        }

    };
})


let markersOnMapDefault = [
    {
        "placeId": 100,
        "placeUrl": "http://o1.bsgdigital.com/",
        "placeImg": "img/mapitem1.jpg",
        "placeImgIcon": "img/marker-map.svg",
        "placeName": "White Square 1",
        "placeTxt": "5, Lesnaya street, Moscow",
        "placeDesc": "NRA: 76,407 sqm <br> Class A",
        "placeLat": 55.75067197263461,
        "placeLng": 37.58271038532258,
        "CenterCoordinatesAlldotsLat": 55.75,
        "CenterCoordinatesAlldotsLng": 37.6167

    },
    {
        "placeId": 4,
        "placeUrl": "http://o1.bsgdigital.com/",
        "placeImg": "img/mapitem1.jpg",
        "placeName": "White Square 2",
        "placeTxt": "5, Lesnaya street, Moscow",
        "placeDesc": "NRA: 76,407 sqm <br> Class A",
        "placeLat": -55.77329031334051,
        "placeLng": 37.62130737304688
    }
];



}
